import React, { Component } from "react";

class Faltantes extends Component {
  render() {
    return (
      <div>
        <fieldset className="col-md-12">
          <legend>LISTADO DE FALTANTES</legend>

          <div className="table-responsive">
            <table className="table table-striped m-b-0 table-hover">
              <colgroup>
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th
                    colSpan="6"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>ESTABLECIMIENTO</b>
                  </th>
                  <th
                    colSpan="2"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>MES</b>
                  </th>
                  <th
                    colSpan="2"
                    style={{
                      textAlign: "center",
                      padding: 1,
                      verticalAlign: "middle",
                    }}
                  >
                    <b>AÑO</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.props.state.establecimientos_faltantes.map(
                  (establecimiento, index) => (
                    <tr key={index}>
                      <td colSpan="6" className="text-center">
                        {establecimiento.razon_social}
                      </td>
                      <td colSpan="2" className="text-center">
                        {establecimiento.mes_nombre || "N/A"}
                      </td>
                      <td colSpan="2" className="text-center">
                        {establecimiento.ano}
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        </fieldset>
      </div>
    );
  }
}

export default Faltantes;
